import { ApplicationProperty } from '@processpuzzle/base-widget';
import { BaseEntityMapper } from '@processpuzzle/base-entity';

/**
 * Wire shape of `processpuzzle-biz-backend`'s `/application-properties`, which is
 * `biz-site-api.yaml`'s `ApplicationProperty`: `{ id, name, value }`, value as a string of digits.
 */
interface ApplicationPropertyDto {
  id?: string;
  name?: string;
  value?: string;
}

/**
 * Maps core's `ApplicationProperty` onto this repository's backend contract.
 *
 * **Hand-written rather than a `SimpleEntityMapper`, and that is not a stylistic choice.** Core's
 * `ApplicationProperty` backs `name` and `value` with the private fields `propertyName` and
 * `propertyValue` and exposes them through accessors, so any mapper built on `Object.assign` or on
 * spreading the instance emits `{ id, propertyName, propertyValue }` — which the backend rejects as
 * a payload with no `name` and no `value`, and which no amount of reading the entity's public
 * surface would predict.
 *
 * It is otherwise identical to core's own `ApplicationPropertyMapper`, which is deliberately not
 * reused: that class is not exported from `@processpuzzle/base-widget`, and this is the seam where
 * a divergence between the two contracts would be absorbed if the json-server mock and this backend
 * ever disagree.
 */
export class BizApplicationPropertyMapper implements BaseEntityMapper<ApplicationProperty> {
  fromDto(dto: unknown): ApplicationProperty {
    const property = (dto ?? {}) as ApplicationPropertyDto;
    return new ApplicationProperty(property.id, property.name, property.value);
  }

  toDto(entity: ApplicationProperty): ApplicationPropertyDto {
    return { id: entity.id, name: entity.name, value: entity.value };
  }
}
